import { Component } from '@angular/core';
import { ModalController, ViewController, NavParams, Events } from 'ionic-angular';
import { HelperMyRadiant, NotesMyTeamProvider, UserMyRadiant } from '@providers/index';
/**
 * Generated class for the ForbidenloginComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'detail-notes',
  templateUrl: 'cmp.html'
})
export class DetailNotesMyTeam {

  text: string;
  data : any;
  skeleton = false;
  loading : any;
  state = "detail";
  parameter_edit: any;
  
  constructor(
    public viewCtrl : ViewController,
    public navParams : NavParams,
    public helper : HelperMyRadiant,
    public notesProvider : NotesMyTeamProvider,
    public events : Events,
    public userApi : UserMyRadiant,

  ) {
    this.data = this.navParams.get("data");
  }

  changeState(state){
    this.state = state;
  }

  tutup(){
    this.viewCtrl.dismiss();
  }

  inactiveNotes(){
    let me = this;
    let options = {
      title:"Confirmation",
      desc:"Are you sure you want to Inactivate this Notes ?",
      inputType:"",
      className:"swal-text-center"
    };
    this.helper.presentSwalConfirmation(options,() => {
      me.actInactive();
    });
  }

  actInactive(){
    let me = this;
    me.loading = me.helper.showLoading("Loading...");
    this.notesProvider.inactive(this.data).subscribe((resp:any) => {
      if (resp.success) {
        me.loading.dismiss();
        me.viewCtrl.dismiss();
        me.events.publish('notes:inactive');
      }
    });
  }

  editNotes(){
    let me = this;
    let params = {
      notes : this.data.notes,
      update_by : this.userApi.data.Employee_ID,
      id : this.data.id,
    };
    // console.log(params)
    me.loading = me.helper.showLoading("Loading...");
    this.notesProvider.editNotes(params).subscribe((resp:any) => {
      if (resp.success) {
        me.loading.dismiss();
        me.viewCtrl.dismiss();
        me.events.publish('notes:edit');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/Content/profil_detail_notes/cmp.ts